<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-if="isSubAgent" v-model="query.subAgentId" @change="getfetchDefaultCompanies"
					filterable clearable placeholder="子代理" class="handle-select mr10" style="width: 260px;">
					<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
						:value="item.id"></el-option>
				</el-select>
				<el-select size="small" v-if="isNormal" v-model="query.companyId" @change="companyChange" filterable
					clearable placeholder="企业" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
					@click="handleSearch">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" class="m_l_10" @click="addTaskVisible"
					v-if="query.companyId">添加任务</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" v-loading="loading"
				:header-cell-style="{ 'text-align': 'center' }" stripe>
				<el-table-column prop="name" label="文件姓名" align="center"></el-table-column>
				<el-table-column prop="status" label="状态" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.status == 'CREATED'" type="warning" size="small">创建</el-tag>
						<el-tag v-if="scope.row.status == 'RUNNING'" type="success" size="small">运行</el-tag>
						<el-tag v-if="scope.row.status == 'PAUSED'" type="danger" size="small">暂停</el-tag>
						<el-tag v-if="scope.row.status == 'COMPLETED'" type="success" size="small">完成</el-tag>
						<el-tag v-if="scope.row.status == 'STOPPED'" type="danger" size="small">停止</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="totalTasks" label="任务总数" align="center"></el-table-column>
				<el-table-column prop="progress" label="进度" align="center">
					<template #default="scope">
						<el-progress :percentage="scope.row.progress?.toFixed(2)"></el-progress>
					</template>
				</el-table-column>
				<el-table-column prop="middlePhone" label="任务中间号" align="center">
					<template #default="scope">
						<el-tag type="success" size="small"
							@click="middlePhoneVisible(scope.row)">{{scope.row.middlePhone.length}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="assignedAgents" label="任务坐席" align="center">
					<template #default="scope">
						<el-tag type="success" size="small"
							@click="assignedAgentVisible(scope.row)">{{scope.row.assignedAgents.length}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="420">
					<template #default="scope">
						<el-button type="primary" size="mini" :class="[theme]"
							@click="getDetails(scope.row)">详情</el-button>
						<el-button type="success" size="mini" icon="el-icon-video-play"
							@click="getStart(scope.row.taskId)" v-if="scope.row.status!=='RUNNING'">开始任务</el-button>
						<el-button type="warning" size="mini" icon="el-icon-video-pause"
							@click="getStop(scope.row.taskId)" v-if="scope.row.status!=='STOPPED'">停止任务</el-button>
						<el-button type="danger" size="mini" icon="el-icon-delete"
							@click="getDelete(scope.row.taskId)">清空任务</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize"
					:total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>
		<el-dialog title="添加任务" v-model="taskVisible" width="680px" @close="closeDialog()"
			:close-on-click-modal="false">
			<el-form :model="form" :rules="form" ref="form" label-width="100px">
				<el-form-item label="线索名称:" prop="name">
					<el-input size="small" v-model="form.name" placeholder="请输入线索名称"></el-input>
				</el-form-item>
				<el-form-item label="线索列表:" prop="fileName">
					<el-radio-group v-model="form.customerFileId">
						<el-radio v-for="item in menuList" :key="item.id" :label="item.id" :value="item.id"
							style="margin:10px;">{{ item.fileName }}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item style="display: flex;flex-direction: row;justify-content: flex-end;">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAddTask">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="详情" v-model="detailsVisible" width="650px" @close="closeDialog2()"
			:close-on-click-modal="false">
			<el-form :model="detailsForm" ref="detailsForm" label-width="100px">
				<el-form-item label="文件名称" prop="name">
					<div>{{detailsForm.name}}</div>
				</el-form-item>
				<div style="display: flex;flex-direction: row;justify-content: space-around;">
					<el-form-item label="文件状态" prop="status">
						<el-tag v-if="detailsForm.status == 'CREATED'" type="warning" size="small">创建</el-tag>
						<el-tag v-if="detailsForm.status == 'RUNNING'" type="success" size="small">运行</el-tag>
						<el-tag v-if="detailsForm.status == 'PAUSED'" type="danger" size="small">暂停</el-tag>
						<el-tag v-if="detailsForm.status == 'COMPLETED'" type="success" size="small">完成</el-tag>
						<el-tag v-if="detailsForm.status == 'STOPPED'" type="danger" size="small">停止</el-tag>
					</el-form-item>
					<el-form-item label="任务总数" prop="totalTasks">
						<div>{{detailsForm.totalTasks||0}}</div>
					</el-form-item>
				</div>
				<div style="display: flex;flex-direction: row;justify-content: space-around;">
					<el-form-item label="待拨号" prop="dialing">
						<div>{{detailsForm.dialing||0}}</div>
					</el-form-item>
					<el-form-item label="已接通" prop="answered">
						<div>{{detailsForm.answered||0}}</div>
					</el-form-item>
				</div>
				<div style="display: flex;flex-direction: row;justify-content: space-around;">
					<el-form-item label="已拨号" prop="dialing">
						<div>{{(detailsForm.totalTasks-detailsForm.dialing)||0}}</div>
					</el-form-item>
					<el-form-item label="接通率" prop="progress">
						<div>
							{{(detailsForm.answered/(detailsForm.totalTasks-detailsForm.dialing)*100).toFixed(2)+'%'||0}}
						</div>
					</el-form-item>
				</div>
				<div style="display: flex;flex-direction: row;justify-content: space-around;">
					<el-form-item label="客户呼叫失败" prop="customer_call_failed">
						<div>{{detailsForm.customer_call_failed||0}}</div>
					</el-form-item>
					<el-form-item label="客户呼叫失败率" prop="customer_call_failed">
						<div>
							{{(detailsForm.customer_call_failed/(detailsForm.totalTasks-detailsForm.dialing)*100).toFixed(2)+'%'||0}}
						</div>
					</el-form-item>
				</div>
				<div style="display: flex;flex-direction: row;justify-content: space-around;">
					<el-form-item label="坐席呼叫失败" prop="agent_call_failed">
						<div>{{detailsForm.agent_call_failed||0}}</div>
					</el-form-item>
					<el-form-item label="坐席呼叫失败率" prop="agent_call_failed">
						<div>
							{{(detailsForm.agent_call_failed/(detailsForm.totalTasks-detailsForm.dialing)*100).toFixed(2)+'%'||0}}
						</div>
					</el-form-item>
				</div>
				<el-form-item label="任务进度" prop="progress">
					<el-progress :percentage="detailsForm.progress?.toFixed(2)" style="margin-top: 13px;"></el-progress>
				</el-form-item>
				<el-form-item label="任务中间号" prop="middlePhone">
					<el-tag v-for="item in detailsForm.middlePhone" :key='item' size="small"
						style="margin-right: 6px;">{{item}}</el-tag>
				</el-form-item>
				<el-form-item label="任务坐席" prop="assignedAgents">
					<el-tag v-for="item in detailsForm.assignedAgents" :key='item' size="small"
						style="margin-right: 6px;">{{item}}</el-tag>
				</el-form-item>
				<el-form-item style="display: flex;flex-direction: row;justify-content: flex-end;">
					<el-button size="small" @click="closeDialog2">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="添加坐席" v-model="addAgentVisible" width="450px" @close="closeDialog3()"
			:close-on-click-modal="false">
			<el-form :model="assignedAgentForm" ref="assignedAgentForm" label-width="80px">
				<el-form-item label="坐席" prop="assignedAgents">
					<el-checkbox-group v-model="assignedAgentForm.assignedAgents" size="small"
						class="fixed-width-group">
						<el-checkbox v-for="item in agentList" :key="item.userPhone" :label="item.userPhone"
							border></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item style="display: flex;flex-direction: row;justify-content: flex-end;">
					<el-button size="small" @click="closeDialog3">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="addAssignedAgent">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="添加中间号" v-model="addMiddlePhoneVisible" width="450px" @close="closeDialog4"
			:close-on-click-modal="false">
			<el-form :model="addMiddlePhoneForm" ref="addMiddlePhoneForm" label-width="80px">
				<el-form-item label="中间号" prop="middlePhone">
					<el-checkbox-group v-model="addMiddlePhoneForm.middlePhone" size="small" class="fixed-width-group">
						<el-checkbox v-for="item in middlePhoneList" :key="item.phone" :label="item.phone"
							border></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item style="display: flex;flex-direction: row;justify-content: flex-end;">
					<el-button size="small" @click="closeDialog4">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="addMiddlePhone">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex.js';
	import {
		fetchDepartment,
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		querySubAgent
	} from '../api/serialIndex.js';
	import {
		recycleCustomers,
	} from '../api/assignLeads.js';
	import {
		addTask,
		getAllTask,
		addAssignedAgent,
		getmiddlePhone,
		start,
		stop,
		deleteTask
	} from '../api/groupcall.js';
	import {
		customerFile,
	} from '../api/customerIndex';
	import {
		accountJobSetMeal,
		sipAccountList
	} from '../api/setMeal.js';
	export default {
		name: 'groupCall',
		data() {
			return {
				query: {
					idNo: '',
					agentId: '',
					subAgentId: '',
					companyId: '',
					pageIndex: 1,
					pageSize: 10,
				},
				form: {
					customerFileId: '',
					name: '',
				},
				tableData: [],
				pageTotal: 0,
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				taskVisible: false,
				isAdmin: false,
				isSubAgent: false,
				isNormal: false,
				role: '',
				menu: {
					pageIndex: 1,
					pageSize: 10
				},
				menuList: [],
				menupageTotal: 0,
				detailsForm: {},
				detailsVisible: false,
				assignedAgentForm: {
					assignedAgents: [],
				},
				addAgentVisible: false,
				agentList: [],
				addMiddlePhoneForm: {
					middlePhone: [],
				},
				addMiddlePhoneVisible: false,
				middlePhoneList: [],
			};
		},

		created() {
			this.role = localStorage.getItem('ms_role');
			this.subAgent = localStorage.getItem('subAgent');
			this.init();
			if (this.role === 'agent') {
				this.isNotAdmin = false;
				this.isAgent = true;
				this.isNormal = true;
				if (this.subAgent == 'true') {
					this.isSubAgent = true;
					this.getquerySubAgent();
				} else {
					this.isSubAgent = false;
				}
			}
			if (this.role === 'subAgent') {
				this.isAgent = true;
			}
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isAgent = true;
				this.isNormal = true;
			}
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			handleSearch() {
				this.query.pageIndex = 1;
				this.getDate()
			},
			handleSizeChange() {},
			handlePageChange() {},
			addTaskVisible() {
				this.getcustomerFile();
			},
			closeDialog() {
				this.taskVisible = false;
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				if (this.subAgent == true) {
					this.isSubAgent = true;
					this.getquerySubAgent();
				}
				this.getfetchDefaultCompanies();
			},
			//子代理
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId,
				};
				fetchDefaultCompanies(data).then(res => {
					if (this.role == 'company' || this.role == 'department') {
						let data = {
							companyId: '',
							currentUserId: localStorage.getItem('user')
						};
						fetchDepartment(data).then(res => {
							this.departments = res.data;
							this.departmentList = res.data;
							this.query.companyId = res.data[0].value;
						});
					} else {
						this.companys = res.data;
					}
				});
			},

			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.departmentList = res.data;
					this.query.pageIndex = 1;
				});
			},

			getcustomerFile() {
				this.loading = true;
				let data = {
					companyId: this.query.companyId,
					name: this.query.name,
					pageIndex: this.menu.pageIndex,
					pageSize: this.menu.pageSize,
					currentUserId: localStorage.getItem('user'),
				};
				customerFile(data).then(res => {
					this.taskVisible = true;
					this.loading = false;
					if (res.data) {
						this.menuList = res.data.list;
						this.menupageTotal = res.data.total;
					}
				});
			},
			getAddTask() {
				this.loading = true;
				this.form.companyId = this.query.companyId;
				addTask(JSON.stringify(this.form)).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.taskVisible = false;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getDate() {
				getAllTask(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getDetails(row) {
				this.detailsVisible = true;
				this.detailsForm = row;
			},
			closeDialog2() {
				this.detailsVisible = false;
				this.detailsForm = {};
			},

			assignedAgentVisible(row) {
				this.assignedAgentForm = row;
				this.getAccountJobSetMeal();
			},
			addAssignedAgent() {
				let data = {
					agents: this.assignedAgentForm.assignedAgents,
				}
				addAssignedAgent(JSON.stringify(data), this.assignedAgentForm.taskId).then(res => {
					if (res?.code === 200) {
						this.addAgentVisible = false;
						this.$message.success(res.data);
						this.assignedAgentForm = {};
						this.getDate();
					} else {
						this.$message.error(res.message);
					}
				});
			},

			closeDialog3() {
				this.addAgentVisible = false;
				this.assignedAgentForm = {};
			},
			getAccountJobSetMeal() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					type: 'sub',
					pageIndex: this.query.pageIndex,
					pageSize: 999999,
				};
				this.loading = true;
				this.agentList = [];
				accountJobSetMeal(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.addAgentVisible = true;
						this.agentList = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			middlePhoneVisible(row) {
				this.addMiddlePhoneForm = row;
				this.getsipAccountList();
			},
			addMiddlePhone() {
				let data = {
					middlePhones: this.addMiddlePhoneForm.middlePhone,
				}
				getmiddlePhone(JSON.stringify(data), this.addMiddlePhoneForm.taskId).then(res => {
					if (res?.code === 200) {
						this.addMiddlePhoneVisible = false;
						this.$message.success(res.data);
						this.addMiddlePhoneForm.middlePhone = [];
						this.middlePhoneList = [];
						this.getDate();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog4() {
				this.addMiddlePhoneVisible = false;
				this.addMiddlePhoneForm = {};
			},
			getsipAccountList() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					pageIndex: this.query.pageIndex,
					pageSize: 999999,
					isUse: true,
				};
				this.loading = true;
				this.middlePhoneList = [];
				sipAccountList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.addMiddlePhoneVisible = true;
						this.middlePhoneList = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//开始
			getStart(taskId) {
				start(taskId).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.getDate();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//暂停
			getStop(taskId) {
				stop(taskId).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.getDate();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//删除任务
			getDelete(taskId) {
				deleteTask(taskId).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.getDate();
					} else {
						this.$message.error(res.message);
					}
				});
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.fixed-width-group .el-checkbox {
		width: 150px;
		margin-right: 0;
		/* 设置固定宽度 */
	}
</style>